import styled from "styled-components";

const Layout = styled.div`
  min-height: inherit;
  height: 100%;
  width: 100%;
  display: grid;
  padding: 16px;
`;

export default Layout;
